import React from 'react';
import { ChevronDown, FileText } from 'lucide-react';
import PolicyItem from './PolicyItem';

const PolicyCategoryCard = ({ category, isExpanded, onToggle }) => {
  return (
    <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl overflow-hidden dark:bg-gray-800/80 dark:border dark:border-gray-700/50">
      <button
        onClick={onToggle}
        className={`w-full flex justify-between items-center p-6 text-left ${
          isExpanded ? 'bg-indigo-50 dark:bg-indigo-900/30' : ''
        }`}
      >
        <div className="flex items-center">
          <div className="bg-indigo-100 dark:bg-indigo-900/30 p-3 rounded-lg mr-4">
            <FileText className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            {category.category}
          </h2>
        </div>
          <ChevronDown
            className={`h-5 w-5 text-gray-500 dark:text-gray-400 transition-transform ${
              isExpanded ? 'transform rotate-180' : ''
            }`}
          />
      </button>

      <div
        className={`transition-all duration-300 overflow-hidden ${
          isExpanded ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="p-6 pt-0 space-y-4">
          {category.policies.map((policy, index) => (
            <PolicyItem key={index} policy={policy} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PolicyCategoryCard;
